  <!-- Animated -->
            <div class="animated fadeIn">
                <!-- <h3>Admin Panel</h3>
                <br/> -->
         
                <!--  Traffic  -->
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-body" style="min-height: 600px;">
                                <h4 class="box-title">Custom Consolidated Report </h4>
                                <!--<a class="float-right rtbtn btn btn-primary" style="margin-top: -35px;" (click)="logout()">Logout</a>-->
                           <br/>
                           		<div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Data Type
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="selectSm" id="selectSm" class="form-control-sm form-control" [(ngModel)]="dataType">
                                           <option value="Segment">Segment</option>
                                            <option value="Form">Form</option>   
                                            <option value="Financial Highlights">Financial Highlights</option>
                                            <option value="Gross & Net Statistics">Gross & Net Statistics</option>
                                            <option value="Data on Motor">Data on Motor</option>
                                            <option value="Reinsurance">Reinsurance</option>
                                            <!--<option value="Large Loss">Large Loss</option>-->
                                        </select>
                                    </div>
                                </div>
                                <div class="row form-group" id="fileYearCont" *ngIf="dataType == 'Segment'">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Year
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="fileYear" id="fileYear" [(ngModel)]="fileYear" class="form-control-sm form-control" >
                                            <option value="{{yr}}" *ngFor="let yr of yearArr">{{yr}}</option>                                           
                                        </select>
                                    </div>
                                </div>
                                <div class="row form-group" id="filefYearCont" *ngIf="dataType != 'Segment'">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Year
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="filefYear" id="filefYear" [(ngModel)]="filefYear" class="form-control-sm form-control">
                                            <option  value="{{fyr}}" *ngFor="let fyr of yearfArr">{{fyr}}</option>           
                                        </select>
                                    </div>
                                </div>
                                <div class="row form-group"  id="selectMonthCont" *ngIf="dataType == 'Segment'">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Month
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="selectMonth" id="selectMonth" [(ngModel)]="selectMonth" class="form-control-sm form-control">
                                            <option value="January">January</option>
                                            <option value="February">February</option>
                                            <option value="March">March</option>
                                            <option value="April">April</option>
                                            <option value="May">May</option>
                                            <option value="June">June</option>
                                            <option value="July">July</option>
                                            <option value="August">August</option>
                                            <option value="September">September</option>
                                            <option value="October">October</option>
                                            <option value="November">November</option> 
                                            <option value="December">December</option> 
                                        </select>
                                    </div>
                                </div>

                                <div class="row form-group" id="fileQuarterCont" *ngIf="dataType == 'Form' || dataType == 'Financial Highlights' || dataType == 'Data on Motor' || dataType == 'Reinsurance'">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Quarter
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="fileQuarter" id="fileQuarter" [(ngModel)]="fileQuarter" class="form-control-sm form-control">
                                            <option value="Q1">Q1</option>
                                            <option value="Q2">Q2</option>
                                            <option value="Q3">Q3</option>
                                            <option value="Q4">Q4</option>                                            
                                        </select>
                                    </div>
                                </div>
                                <!--<div class="row form-group" id="comCont" >
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Insurer
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select multiple name="company" id="company" [(ngModel)]="company" class="form-control-sm form-control" (change)="changeCompany($event.target)">
                                            <option value="All Insurer" >All Insurer</option>
                                            <option [value]="cd.companyId" *ngFor="let cd of comData">{{cd.companyName}}</option>
                                        </select>
                                    </div>
                                </div>-->
                                <div class="row form-group" *ngIf="dataType == 'Form' || dataType == 'Data on Motor' || dataType == 'Reinsurance'">
                                    <div class="col col-md-3"><label for="formType" class=" form-control-label">
                                        Form Type
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="formType" id="formType" class="form-control-sm form-control" [(ngModel)]="formType">
                                            <option value="0" *ngIf="dataType == 'Form'">Form I</option>
                                            <option value="1" *ngIf="dataType == 'Form'">Form II</option>   
                                            <option value="2" *ngIf="dataType == 'Form'">Form III</option>
                                            <option value="3" *ngIf="dataType == 'Form'">Form IV</option>
                                            <option value="4" *ngIf="dataType == 'Form'">Form V</option>
                                            <option value="5" *ngIf="dataType == 'Form'">Form VI</option>
                                            <option value="6" *ngIf="dataType == 'Form'">Form VIII</option>
                                            <!--<option value="7">Form IX</option>-->
                                            <option value="8" *ngIf="dataType == 'Form'">Form X</option>

                                            <option value="0" *ngIf="dataType == 'Data on Motor'">Motor 2W</option>
                                            <option value="1" *ngIf="dataType == 'Data on Motor'">Motor 3W</option>   
                                            <option value="2" *ngIf="dataType == 'Data on Motor'">Motor 4W Pvt Car</option>
                                            <option value="3" *ngIf="dataType == 'Data on Motor'">Motor CV Pass Carry</option>
                                            <option value="4" *ngIf="dataType == 'Data on Motor'">Motor CV Goods Carry</option>
                                            <option value="5" *ngIf="dataType == 'Data on Motor'">Motor CV Miscellaenous</option>
                                            <option value="6" *ngIf="dataType == 'Data on Motor'">Motor Others</option>

                                            <option value="Indian-Business" *ngIf="dataType == 'Reinsurance'">Indian Business</option>
                                            <option value="Foreign-Business" *ngIf="dataType == 'Reinsurance'">Foreign Business</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="row form-group" id="formReportTypeCont" *ngIf="dataType == 'Segment' || dataType == 'Form' || dataType == 'Data on Motor' || dataType == 'Gross & Net Statistics' || dataType == 'Reinsurance'">
                                    <div class="col col-md-3"><label for="formReportType" class=" form-control-label">
                                        Report Type
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="formReportType" id="formReportType" [(ngModel)]="formReportType" class="form-control-sm form-control" >
                                            <option value="LOB" *ngIf="dataType == 'Form' && (formType!='8' && formType!='6')">LOB Wise</option>
                                            <option value="Location" *ngIf="dataType == 'Form' && (formType == '0' || formType == '2' || formType == '3' || formType == '8')" >Location Wise</option>
                                            <option value="Type Of Channel" *ngIf="dataType == 'Form' && (formType == '1' || formType == '4')">Type Of Channel Wise</option>
                                            <option value="Details" *ngIf="dataType == 'Form' && (formType == '5' || formType == '6')">Details Wise</option>
                                            <option value="No-of-Office" *ngIf="dataType == 'Form' && formType=='8'">No. of Office Wise</option>
                                            <option value="Micro-Insurance" *ngIf="dataType == 'Form' && formType=='6'">Micro Insurance</option>

                                            <option value="LOB" *ngIf="dataType == 'Data on Motor'">LOB Wise</option>
                                            <option value="Location" *ngIf="dataType == 'Data on Motor'" >Location Wise</option>

                                            <option value="LOB" *ngIf="dataType == 'Gross & Net Statistics'">LOB Wise</option>
                                            <option value="Details" *ngIf="dataType == 'Gross & Net Statistics'" >Details Wise</option>
                                            <option value="LOB" *ngIf="dataType == 'Segment'">LOB Wise</option>
                                            <option value="Details" *ngIf="dataType == 'Segment'" >Details Wise</option>

                                            <option value="LOB" *ngIf="dataType == 'Reinsurance'">LOB Wise</option>
                                            <option value="Details" *ngIf="dataType == 'Reinsurance'" >Details Wise</option>

                                        </select>
                                    </div>
                                </div>
                               <div class="row form-group" id="formReportColCont" *ngIf="(dataType == 'Gross & Net Statistics' && formReportType=='LOB') || (dataType == 'Segment' && formReportType=='LOB') || (dataType == 'Reinsurance' && formReportType=='LOB')">
                                    <div class="col col-md-3"><label for="formReportCol" class=" form-control-label">
                                        Report Field
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="formReportCol" id="formReportCol" [(ngModel)]="formReportCol" class="form-control-sm form-control" >
                                           <!-- <option value="Number" *ngIf="dataType == 'Form' && formType!='8'">Number</option>
                                            <option value="Amount" *ngIf="dataType == 'Form' && formType!='8'">Amount</option>
                                            <option value="Total" *n <ogIf="dataType == 'Form' && formType=='8'">Total</option>-->
                                            <option value="Gross-Direct-Premium" *ngIf="(dataType == 'Gross & Net Statistics' && formReportType=='LOB')">Gross Direct Premium</option>
                                            <option value="Gross-Written-Premium" *ngIf="(dataType == 'Gross & Net Statistics' && formReportType=='LOB')">Gross Written Premium</option>
                                            <option value="Net-Premium" *ngIf="(dataType == 'Gross & Net Statistics' && formReportType=='LOB')">Net Premium</option>
                                            <option value="Net-Earned-Premium" *ngIf="(dataType == 'Gross & Net Statistics' && formReportType=='LOB')">Net Earned Premium</option>
                                            <option value="Gross-Incurred-Claims" *ngIf="(dataType == 'Gross & Net Statistics' && formReportType=='LOB')">Gross Incurred Claims</option>
                                            <option value="Net-Incurred-Claims" *ngIf="(dataType == 'Gross & Net Statistics' && formReportType=='LOB')">Net Incurred Claims</option>
                                            <option value="Gross-Commission" *ngIf="(dataType == 'Gross & Net Statistics' && formReportType=='LOB')">Gross Commission</option>
                                            <option value="Net-Commission" *ngIf="(dataType == 'Gross & Net Statistics' && formReportType=='LOB')">Net Commission</option>

                                            <option value="Total-Premium" *ngIf="(dataType == 'Segment' && formReportType=='LOB')">Total Premium u/w</option>
                                            <option value="Total-No-of-Policies-issued" *ngIf="(dataType == 'Segment' && formReportType=='LOB')">Total No. of Policies issued</option>
                                            <option value="Accretions-during-the-month" *ngIf="(dataType == 'Segment' && formReportType=='LOB')">Accretions during the month</option>
                                            <option value="Sum-Assured" *ngIf="(dataType == 'Segment' && formReportType=='LOB')">Sum Assured</option>
                                            <option value="Amount-of-Premium-in-Rural-Areas" *ngIf="(dataType == 'Segment' && formReportType=='LOB')">Amount of Premium u/w in Rural Areas</option>
                                            <option value="No-of-Polices-issued-in-Rural-Areas" *ngIf="(dataType == 'Segment' && formReportType=='LOB')">No. of Polices issued in Rural Areas</option>
                                            <option value="Amount-of-Premium-in-Social-Sector" *ngIf="(dataType == 'Segment' && formReportType=='LOB')">Amount of Premium u/w in Social Sector</option>
                                            <option value="No-of-Persons-covered-in-Social-Sector" *ngIf="(dataType == 'Segment' && formReportType=='LOB')">No. of Persons covered in Social Sector</option>
                                            <option value="No-of-Persons-covered" *ngIf="(dataType == 'Segment' && formReportType=='LOB')">No. of Persons covered</option>
                                            <option value="New-Products-introduced-during-the-month" *ngIf="(dataType == 'Segment' && formReportType=='LOB')">New Products introduced during the month</option>

                                            <option value="Gross-Premium-Income-For-the-Quarter" *ngIf="(dataType == 'Reinsurance' && formReportType=='LOB')">Gross Premium Income(For the Quarter)</option>
                                            <option value="Gross-Premium-Income-Upto-the-Quarter" *ngIf="(dataType == 'Reinsurance' && formReportType=='LOB')">Gross Premium Income(Upto the Quarter)</option>
                                            <option value="Retroceded-Premium-For-the-Quarter" *ngIf="(dataType == 'Reinsurance' && formReportType=='LOB')">Retroceded Premium(For the Quarter)</option>
                                            <option value="Retroceded-Premium-Upto-the-Quarter" *ngIf="(dataType == 'Reinsurance' && formReportType=='LOB')">Retroceded Premium(Upto the Quarter)</option>
                                        </select>
                                    </div>
                               </div>
                               <div class="row form-group">
                                    <div class="col col-md-3"></div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-actions form-group">
                                            <button type="submit" class="btn btn-primary btn-sm" (click)="generateReport()" >Generate</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-12" id="errCont"></div>
                                </div>
                            </div>
                        </div>
                    </div><!-- /# column -->
                </div>
                <!--  /Traffic -->
                <div class="clearfix"></div>
               
              
               
                
                
            </div>
            <!-- .animated -->






<!--<div class="loaderbox" *ngIf="loaderVisibility" id="loaderbox">
    <div class="load" >
        <img src="assets/images/loading.gif" alt="" >
    </div>
</div>
-->


















